import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadRegistrySmevCheckListBegin, loadRegistrySmevCheckListFailed, loadRegistrySmevCheckListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import {
  BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY, SUBJECT_TYPE,
} from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* loadRegistrySmevCheckList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
      sort,
    } = payload;
    let pool = {
      subject_types: [SUBJECT_TYPE.CARRIER, SUBJECT_TYPE.ORDER_SERVICE, SUBJECT_TYPE.VEHICLE],
      limit,
      page,
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(filter, pool);
    }
    if (typeof sort === 'string' && sort.length) {
      pool = { ...pool, sort };
    }
    const url = `${BACKEND_URL}/resources/checks/`;
    yield put(loadRegistrySmevCheckListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadRegistrySmevCheckListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadRegistrySmevCheckListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadRegistrySmevCheckListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
